const Notice = {

  init: function () {
    let notices = document.querySelector('.notice');
    if (notices) {
      Notice.enableCloseButton(notices)
    }
  },

  enableCloseButton: function(notice) {
    let closeButtons = notice.querySelectorAll('.button.close');
    [].forEach.call(closeButtons, function(closeButton) {
      Notice.closeButton(closeButton)
    });
  },

  closeButton: function(btn) {
    btn.addEventListener('click', function() {
      let noticeWrapper = this.parentElement;
      $.ajax({
        type: 'POST',
        url: noticeWrapper.dataset.remoteUrl,
        success: function() {
          noticeWrapper.classList.add('close');
        }
      });
    });
  }

};

export default Notice;